interface CardWithImageBackgroundProps {
  title: string
  body: string
  className?: string
  variant?: 'gradient' | 'turquoise'
}

export function CardWithImageBackground({ 
  title, 
  body, 
  className = '',
  variant = 'gradient'
}: CardWithImageBackgroundProps) {
  return (
    <div className={`relative overflow-hidden rounded-lg ${className}`}>
      <div className={`absolute inset-0 ${
        variant === 'turquoise' 
          ? 'bg-gradient-to-tr from-cyan-400 via-cyan-200 to-white' 
          : 'bg-gradient-to-br from-purple-500/30 via-orange-500/30 to-green-500/30'
      }`} />
      <div className="absolute inset-0 backdrop-blur-[2px] bg-white/5" />
      <div className="relative z-10 p-6">
        <h3 className="text-xl font-semibold mb-2 text-black dark:text-white">{title}</h3>
        <p className="text-gray-800 dark:text-gray-200">{body}</p>
      </div>
    </div>
  )
} 